import { StepData } from '@frontend/design-system';
import { CareCreditEnrollmentMultiSteps, StepConfigProps } from '../enrollment-multi-step.types';

export type EnrollmentStepData = StepData & { id: CareCreditEnrollmentMultiSteps };

export const getEnrollmentSteps = (): EnrollmentStepData[] => {
  const stepIds: { id: CareCreditEnrollmentMultiSteps }[] = [
    { id: 'select-process-method' },
    { id: 'new-application-form' },
    { id: 'applicant-pre-qualified-confirm' },
    { id: 'application-details-submit' },
    { id: 'application-confirmation-result' },
  ];

  return stepIds.map((s) => {
    return {
      ...s,
      label: '',
      isValid: false,
      isComplete: false,
      childSteps: [],
    };
  });
};

export const getParentStepConfig = (stepId: CareCreditEnrollmentMultiSteps): StepConfigProps => {
  const showHeader = ['select-process-method', 'new-application-form'].includes(stepId) ? true : false;
  return { showHeader };
};
